import { Upload, Ruler } from "lucide-react";
import { IDS } from "@/constants/testIds";

const MeasField = ({ label, testId, value, onChange }) => (
  <label className="flex flex-col gap-2">
    <span className="text-[10px] font-[Manrope] font-bold tracking-[0.2em] uppercase text-stone-500">{label}</span>
    <input data-testid={testId} className="input" type="number" value={value} onChange={onChange} />
  </label>
);

export default function OnboardingStep2({
  bodyMode, setBodyMode, photoFile, setPhotoFile, meas, setMeas,
  analyzing, onPhotoUpload, onSaveMeasurements,
}) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2 p-1 bg-stone-100 rounded-full self-start">
        <button
          onClick={() => setBodyMode("photo")}
          className={`px-4 py-2 rounded-full text-sm font-[Manrope] ${bodyMode === "photo" ? "bg-white shadow-sm text-stone-900" : "text-stone-500"}`}
        >
          Full-body photo
        </button>
        <button
          onClick={() => setBodyMode("measure")}
          className={`px-4 py-2 rounded-full text-sm font-[Manrope] ${bodyMode === "measure" ? "bg-white shadow-sm text-stone-900" : "text-stone-500"}`}
        >
          Measurements
        </button>
      </div>
      <p className="text-sm font-[Manrope] text-stone-600 leading-relaxed">
        We use this only to give you flattering, positive style guidance. Nothing is shared.
      </p>

      {bodyMode === "photo" ? (
        <div className="flex flex-col gap-3">
          <label className="border-2 border-dashed border-stone-300 rounded-2xl p-8 flex flex-col items-center gap-3 cursor-pointer bg-white hover:bg-stone-50 transition-colors">
            <Upload size={20} strokeWidth={1.5} className="text-[#6B7A54]" />
            <span className="font-[Manrope] text-sm text-stone-600">
              {photoFile ? photoFile.name : "Tap to add a full-body photo"}
            </span>
            <input
              type="file"
              accept="image/*"
              className="hidden"
              data-testid={IDS.bodyPhotoInput}
              onChange={(e) => setPhotoFile(e.target.files?.[0] || null)}
            />
          </label>
          <button onClick={onPhotoUpload} disabled={!photoFile || analyzing} className="btn-primary">
            {analyzing ? "Analyzing…" : "Analyze photo"}
          </button>
          <button
            data-testid={IDS.onbSkipPhoto}
            onClick={() => setBodyMode("measure")}
            className="text-sm font-[Manrope] text-stone-500 underline underline-offset-4 self-center"
          >
            I&rsquo;d rather enter measurements
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          <MeasField label="Height (cm)" testId={IDS.measHeight} value={meas.height_cm} onChange={(e)=>setMeas({...meas, height_cm:e.target.value})} />
          <MeasField label="Weight (kg)" testId={IDS.measWeight} value={meas.weight_kg} onChange={(e)=>setMeas({...meas, weight_kg:e.target.value})} />
          <MeasField label="Shoulder (cm)" testId={IDS.measShoulder} value={meas.shoulder_cm} onChange={(e)=>setMeas({...meas, shoulder_cm:e.target.value})} />
          <MeasField label="Waist (cm)" testId={IDS.measWaist} value={meas.waist_cm} onChange={(e)=>setMeas({...meas, waist_cm:e.target.value})} />
          <MeasField label="Hip (cm)" testId={IDS.measHip} value={meas.hip_cm} onChange={(e)=>setMeas({...meas, hip_cm:e.target.value})} />
          <div className="col-span-2">
            <button onClick={onSaveMeasurements} disabled={analyzing} className="btn-primary">
              <Ruler size={16} strokeWidth={1.5} /> {analyzing ? "Deriving…" : "Derive silhouette"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
